//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import Roles from '@/security/roles';
import vueI18n from '@/vueI18n'
// import i18n from '@/vueI18n';
// import { i18n } from '@/vueI18n';
import moment from 'moment';

import { IamPermissions } from '@/modules/iam/iam-permissions';
import { UserModel } from '@/modules/auth/user-model';
const { fields } = UserModel;

export default {
  name: 'app-iam-list-table',

  mounted() {
    this.doFilter();
    this.doMountTable(this.$refs.table);
  },

  data() {
    return {
      filter: '',
      selection:[],
      selectedRow: null,
      selectedId: null,
      modalVisible: false,
      dialogVisible: false,
      pageSize: 5,
      nextPage: 2,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        // sortBy: 'createdAt',
        // descending: false,
        // rowsNumber: xx if getting data from a server
      },
      columns: [
        {
          name: 'avatarsIam',
          field: 'avatarsIam',
          label: 'user.fields.avatars', 
          align: 'center',
          // required: true,
        },
        {
          name: 'fullName',
          field: 'fullName',
          label: 'user.fields.fullName', 
          align: 'center',
          format: (val) => `${val}`,
          required: true,
          // sortable: true,
        },
        {
          name: 'phoneNumber',
          field: 'phoneNumber',
          label: 'tables.admins.phoneNumber',
          align: 'center',
        },
        {
          name: 'email',
          field: 'email',
          label: 'tables.admins.email',
          align: 'center',
        },
        {
          name: 'roles',
          field: 'roles',
          label: 'tables.admins.role',
          align: 'center',
        },
        {
          name: 'createdAt',
          field: 'createdAt',
          label: 'tables.admins.createdAt',
          align: 'center',
        },
        {
          name: 'time',
          field: 'createdAt',
          label: 'common.time',
          align: 'center',
          // required: true,
          // sortable: true,
        },
        {
          name: 'status',
          field: 'disabledAsStatus',
          label: 'tables.admins.status',
          align: 'center',
        },
        {
          name: 'action',
          field: 'action',
          label:  'tables.admins.action',
          align: 'center',
        },
      ],
      // rows:[]
    };
  },
  computed: {
    ...mapGetters({
      rows: 'iam/list/rows',
      count: 'iam/list/count',
      loading: 'iam/list/loading',
      toggleStatusloading: 'iam/view/statusLoading',
      // pagination: 'guide/list/pagination',
      // paginationLayout: 'layout/paginationLayout',
      
      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    loadingAndUpdate(){
      return this.loading || this.destroyLoading
    },
    hasPermissionToEdit() {
      return new IamPermissions(this.currentUser).edit;
    },
    fields() {
      return fields;
    },
    language(){
      return vueI18n.locale
    },
    pagesNumber () {
      return Math.ceil(this.rows.length / this.pagination.rowsPerPage)
    },
  },
  methods: {
    ...mapActions({
      doChangeSort: 'iam/list/doChangeSort',
      doChangePaginationCurrentPage: 'iam/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize: 'iam/list/doChangePaginationPageSize',
      doMountTable: 'iam/list/doMountTable',
      doFetch: 'iam/list/doFetch',
      doToggleUserAccountStatus: 'iam/view/doToggleUserAccountStatus',
      doDestroy: 'iam/list/doDestroy'
    }),
    i18n(key, args) {
      // return i18n(key, args);
      return this.$t(key, args);
    },
    roleDescriptionOf(roleId) {
      return Roles.descriptionOf(roleId);
    },
    roleLabelOf(roleId) {
      return Roles.labelOf(roleId);
    },

    presenterAvatar(row, fieldName) {
      const val = UserModel.presenter(row, fieldName);
      return val;
    },
    presenter(row, fieldName) {
      const val = UserModel.presenter(row, fieldName);
      return val ? val : 'ـــ';
    },
    presenterEnum(row, fieldName) {
      const options = this.fields[fieldName].options;
      const val = options.filter(el => el.value == row[fieldName])
      return val.length ? val[0].label : 'ـــ';
    },
    presenterMap(row, fieldName) {
      const val = UserModel.presenter(row, fieldName);
      return val[this.currentLanguageCode] ? val[this.currentLanguageCode] : 'ـــ'; 
    },
    presenterDateTime(row, fieldName) {
      const val = UserModel.presenter(row, fieldName);
      return val ? moment(val).locale(this.currentLanguageCode).format("DD-MM-YYYY h:mm A") : 'ـــ'; 
    },
    presenterDate(val) {
      // const val = UserModel.presenter(row, fieldName)
      return val ? moment(val).locale(this.currentLanguageCode).format("D MMM, YYYY") : 'ـــــــ'; 
    },
    presenterDay(row, fieldName) {
      return moment(UserModel.presenter(row, fieldName)).locale(this.currentLanguageCode).format("dddd");
    },
    presenterTime(row, fieldName) {
      // let now = moment().locale('en').format('YYYY/MM/DD');
      // let time = UserModel.presenter(row, fieldName)
      let n = row[fieldName]

      // console.log();
      // let date =  `${now} ${time}`;
      return moment(n,"YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").locale(this.currentLanguageCode).format('hh:mm a')
    },
    presenterUser(row, fieldName, key) {
      const user = UserModel.presenter(row, fieldName);
      if (key == 'avatars' || key == 'avatar') {
        let avatar = null
        if (user && Array.isArray(user[key])) {
          avatar = user[key].length ? user[key][0].publicUrl : null
        } else if (user && user[key]) {
          avatar = user[key].publicUrl 
        }
        return avatar ? avatar : 'https://firebasestorage.googleapis.com/v0/b/puricom-beebe.appspot.com/o/public%2Fdefault%2Favatar.svg?alt=media&token=439fb6e6-815f-453e-9e3a-79dc0ab3d40c'
      }
      return user && user[key] ? user[key] : 'ـــ'; 
    },
    presenterClient(row, fieldName, key) {
      const val = UserModel.presenter(row, fieldName);
      return val && val[key] ? val[key] : 'ـــ'; 
    },
    presenterLocalization(data) {
      if (typeof data === 'object' && data !== null) {
        return data[this.currentLanguageCode] ? data[this.currentLanguageCode] : data['en']
        // if (this.currentLanguageCode in data) {
        //   return data[this.currentLanguageCode]
        // }
      }
      return  
    },

    onModalOpen(row) {
      this.selectedRow = row;
      this.selectedId = row.id;
      this.modalVisible = true
      this.dialogVisible = true
    },
    onModalClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.modalVisible = false;
      }, 200);
    },
    onModalSuccess() {
      this.onModalClose();
    },
    async doDestroyWithConfirm(id) {
      console.log(id);
      try {
        await this.doDestroy(id);
        this.onModalClose()
        const filter = { accountType: 'admin' };
      return this.doFetch({
        filter,
      });
      } catch (error) {
        // no
      }
    },

    async doFilter() {
      // try {
      //   await this.$refs.form.validate();
      //   this.$refs.form.clearValidate();
      // } catch (error) {
      //   return;
      // }
      const filter = { accountType: 'admin' };
      return this.doFetch({
        filter,
      });
    },
    async toggleAccountStatus(id) {
      console.log(id);
      this.doToggleUserAccountStatus(id)
    },

  },
};
